import { formatDateDisplay, parseDate } from '@/utils/date';

/**
 * A calendar day from the API (YYYY-MM-DD) in the portal's display day, dd/MM/yyyy, so every
 * date on the page reads like the period picker above it.
 *
 * The day is parsed and printed in the same local zone, so no browser timezone can move it
 * to the day before or after. Anything that is not a YYYY-MM-DD day is returned unchanged:
 * showing the raw value beats a blank where a date belongs.
 */
export function formatDashboardDay(day: string): string {
    const parsed = parseDate(day, 'yyyy-MM-dd');
    return parsed ? formatDateDisplay(parsed) : day;
}
